import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { NikoFacilityOrderInsuranceReviewPreviewViewStore } from "../stores";
import { NikoFacilityOrderInsuranceReviewPreviewTemplate } from "themes/application/niko-facility-order-insurance-review/pages";

@setCurrentView(rootStore => new NikoFacilityOrderInsuranceReviewPreviewViewStore(rootStore), "nikoFacilityOrderInsuranceReviewPreviewViewStore")
@observer
class NikoFacilityOrderInsuranceReviewPreview extends React.Component {
	render() {
		return <NikoFacilityOrderInsuranceReviewPreviewTemplate {...this.props} />;
	}
}

export default NikoFacilityOrderInsuranceReviewPreview;